import React from "react";
import Select from "react-select";

const AutoSelect = ({ error, ...rest }) => {
  return (
    <React.Fragment>
      <Select {...rest} />
      {error && <small className="text-danger help-block">{error}</small>}
    </React.Fragment>
  );
};

export default AutoSelect;
